import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "service-category__inner" }
const _hoisted_3 = { class: "service-category__header" }
const _hoisted_4 = { class: "service-category__back" }
const _hoisted_5 = { class: "service-category__search" }
const _hoisted_6 = {
  key: 1,
  class: "service-category__body"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "sc-grid"
}
const _hoisted_9 = { class: "sc-grid__inner" }
const _hoisted_10 = { class: "sc-card__inner" }
const _hoisted_11 = { class: "sc-card__icon" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "sc-card__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Back = _resolveComponent("Back")!
  const _component_ap_search = _resolveComponent("ap-search")!
  const _component_ap_loader = _resolveComponent("ap-loader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['service-category', {'service-category--fromMain': _ctx.fromMain}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Back, {
              title: _ctx.t('pay_serivces'),
              redirect: _ctx.redirect,
              vertical: _ctx.isDefault,
              showIcon: !_ctx.fromMain
            }, null, 8, ["title", "redirect", "vertical", "showIcon"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ap_search, {
              placeholder: _ctx.t('services.search_placeholder'),
              onInput: _ctx.filter
            }, null, 8, ["placeholder", "onInput"])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ap_loader, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!_ctx.catalogsList.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Не найдено"))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogsList, (catalog) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: catalog.id,
                          class: "sc-grid__item"
                        }, [
                          _createVNode(_component_router_link, {
                            to: { name: _ctx.routeName, params: { id: catalog.id, name: catalog.name, fromMain: _ctx.fromMain }}
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(['sc-card', {'sc-card--service': _ctx.isService }])
                              }, [
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("img", {
                                      src: catalog.icon || catalog.image,
                                      alt: "icon"
                                    }, null, 8, _hoisted_12)
                                  ]),
                                  _createElementVNode("div", _hoisted_13, _toDisplayString(catalog.name), 1)
                                ])
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ])
                  ]))
            ]))
      ])
    ], 2)
  ]))
}